/* @ngInject */
function run (InitializerService, $rootScope, $state) {
  InitializerService.initApplication()

  // Intercepta mudanças de rotas para verificar status de confirmação de email
  $rootScope.$on('$stateChangeStart', (event, toState, toParams, fromState) => {
    // Lista de rotas que não devem ser interceptadas
    const exemptStates = [
      'login',
      'loginSso',
      'signup',
      'userVerification',
      'rememberPassword',
      'recoverPassword',
      'twoFactorVerification',
      'updatePassword',
      'inactive',
      'blockLogins',
      'welcome',
      'signupWorkflowPlan',
      'emailConfirmation',
      'onboardingStepWaitingEmailConfirmation'
    ]

    // Verifica se a rota de destino é pública, isenta ou é um estado de guest/assetPack
    const isExemptState = exemptStates.includes(toState.name) ||
                          toState.public ||
                          toState.name.startsWith('guest') ||
                          toState.name.startsWith('assetPack')

    if (isExemptState) {
      return // Não interfere em rotas públicas ou isentas
    }

    // Verifica se o usuário existe e se está pendente de confirmação de email
    $rootScope.getUser().then((user) => {
      if (user && user.pendingEmailConfirmation) {
        // Previne a navegação e redireciona para confirmação de email
        event.preventDefault()
        $state.go('onboardingStepWaitingEmailConfirmation')
      }
    }).catch(() => {
      // Se não conseguir obter o usuário, não interfere na navegação
      // Isso pode acontecer durante o carregamento inicial ou logout
    })
  })
}

export const deskfyRun = run
